
// listenActive();

import { toProxy } from "../watcher/proxyWatch";
export const documentHiddenData = {isHidden:false}
// toProxy({
//     isHidden:false
// })
export function listenDocumentActive(){
    var hiddenProperty = 'hidden' in document ? 'hidden' :
        'webkitHidden' in document ? 'webkitHidden' :
            'mozHidden' in document ? 'mozHidden':'';
    var visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
    var onVisibilityChange = function () {
        if (!(document as any)[hiddenProperty]) {
            // console && console.log('page active', window.location.href);
            documentHiddenData.isHidden = false;
            document.dispatchEvent(new Event(documentEventTypeDocumentIsShow))
        } else {
            // console && console.log('page deactive', window.location.href);
            documentHiddenData.isHidden = true;
            document.dispatchEvent(new Event(documentEventTypeDocumentIsHidden))
        }
    }
    document.addEventListener(visibilityChangeEvent, onVisibilityChange);
}

export const documentEventTypeDocumentIsShow = "documentEventTypeDocumentIsShow";

export const documentEventTypeDocumentIsHidden = "documentEventTypeDocumentIsHidden";


//获取document信息
export function getDocumentScollPostion() {
    var t, l, w, h;
    if (document.documentElement && document.documentElement.scrollTop) {
        t = document.documentElement.scrollTop;
        l = document.documentElement.scrollLeft;
        w = document.documentElement.scrollWidth;
        h = document.documentElement.scrollHeight;
    } else if (document.body) {
        t = document.body.scrollTop;
        l = document.body.scrollLeft;
        w = document.body.scrollWidth;
        h = document.body.scrollHeight;
    }
    return {
        top: t,
        left: l,
        width: w,
        height: h
    };
}